<nav class="nav-bar">
  @if (!isOpen) {
    <div class="container p-sm-0">
      <div class="nav-content">
        <!-- LOGO -->
        <div class="logo-column" [ngClass]="{ 'logo-center': isSmallScreen }" [routerLink]="'home'">
          <img src="assets/images/classit_logo_publishing.svg" alt="logo" />
        </div>

        <!-- MENU -->
        @if (isSmallScreen) {
          <!-- DROPDOWN MENU -->
          <div class="menu-colum">
            <nmfta-button [blackText]="true" iconName="menu" (buttonClick)="toggleNavMenu()"></nmfta-button>
          </div>
        } @else {
          <!-- HORIZONTAL MENU -->
          <div class="button-column">
            @if (userLoading$()) {
              <div class="button-row">
                <ngx-skeleton-loader
                  count="1"
                  [theme]="{
                    width: '15em',
                    height: '2rem',
                    'border-radius': '0.5rem',
                  }">
                </ngx-skeleton-loader>
              </div>
            } @else {
              <div class="button-row">
                @if (hasUserInformation$()) {
                  <!-- USER MENU-->
                  <nmfta-button
                    [blackText]="true"
                    [matMenuTriggerFor]="menuUser"
                    leftIcon="person"
                    rightIcon="keyboard_arrow_down">
                    {{ user$.firstName!() + ' ' + user$.lastName!() }}
                  </nmfta-button>
                  <mat-menu #menuUser="matMenu">
                    <button mat-menu-item class="custom-red-button" (click)="signOut()">
                      <nmfta-icon name="logout" class="custom-red-button"></nmfta-icon>
                      {{ 'Generic_Logout' | translate }}
                    </button>
                  </mat-menu>

                  @if (isClassificationManager$()) {
                    <!-- ADMIN MENU -->
                    <nmfta-button
                      [blackText]="true"
                      [matMenuTriggerFor]="menuAdmin"
                      leftIcon="build"
                      rightIcon="keyboard_arrow_down">
                      {{ 'Generic_Admin' | translate }}
                    </nmfta-button>
                    <mat-menu #menuAdmin="matMenu">
                      <button mat-menu-item [routerLink]="'admin/manage-publishing-cycle'">
                        {{ 'Generic_ManagePublishingCycle' | translate }}
                      </button>
                      <button mat-menu-item [routerLink]="'admin/manage-distribution-channels'">
                        {{ 'Generic_ManageDistributionChannels' | translate }}
                      </button>
                      <button mat-menu-item [routerLink]="'admin/manage-proposal-templates'">
                        {{ 'Generic_ManageProposalTemplatesFields' | translate }}
                      </button>
                      <button mat-menu-item [matMenuTriggerFor]="menuManageReviewProcess">
                        {{ 'Generic_ManageReviewProcess' | translate }}
                      </button>
                      <button mat-menu-item [routerLink]="'admin/manage-disposition-definitions'">
                        {{ 'Generic_ManageDispositionDefinitions' | translate }}
                      </button>
                      <button mat-menu-item [routerLink]="'admin/manage-reference-marks'">
                        {{ 'Generic_ManageReferenceMarks' | translate }}
                      </button>
                    </mat-menu>

                    <mat-menu #menuManageReviewProcess="matMenu">
                      <button mat-menu-item [routerLink]="'admin/manage-workflows'">
                        {{ 'Generic_ManageWorkflow' | translate }}
                      </button>
                      <button mat-menu-item [routerLink]="'admin/manage-reviewers-approvers'">
                        {{ 'Generic_ManageReviewersAndApprovers' | translate }}
                      </button>
                    </mat-menu>
                  }
                } @else {
                  <!-- LOGIN -->
                  <nmfta-button [blackText]="true" leftIcon="login" (buttonClick)="signIn()">
                    {{ 'Generic_Login' | translate }}
                  </nmfta-button>
                }
                <!-- LANGUAGE -->
                <nmfta-button
                  [blackText]="true"
                  [matMenuTriggerFor]="menuLanguage"
                  leftIcon="language"
                  rightIcon="keyboard_arrow_down">
                  {{ langLabel }}
                </nmfta-button>
                <mat-menu #menuLanguage="matMenu">
                  <button mat-menu-item (click)="useLanguage('en')">
                    @if (langSelected === 'en') {
                      <mat-icon fontSet="material-icons-outlined">check</mat-icon>
                    }
                    {{ 'Generic_English' | translate }}
                  </button>
                  <button mat-menu-item (click)="useLanguage('fr')">
                    @if (langSelected === 'fr') {
                      <mat-icon fontSet="material-icons-outlined">check</mat-icon>
                    }
                    {{ 'Generic_French' | translate }}
                  </button>
                  <button mat-menu-item (click)="useLanguage('es')">
                    @if (langSelected === 'es') {
                      <mat-icon fontSet="material-icons-outlined">check</mat-icon>
                    }
                    {{ 'Generic_Spanish' | translate }}
                  </button>
                </mat-menu>
                @if (hasUserInformation$()) {
                  <nmfta-button
                    [blackText]="true"
                    iconName="file_download"
                    (buttonClick)="openDownloadsPanel()">
                  </nmfta-button>
                }
              </div>
            }
            @if (userLoading$()) {
              <div class="button-row">
                <ngx-skeleton-loader
                  count="1"
                  [theme]="{
                    width: '30rem',
                    height: '2rem',
                    'border-radius': '0.5rem',
                  }">
                </ngx-skeleton-loader>
              </div>
            } @else {
            @if (hasUserInformation$()) {
              <div class="button-row">
                <!-- HOME -->
                <nmfta-button [blackText]="true" (buttonClick)="navigate('home')"> Home </nmfta-button>

                <!-- PROPOSALS -->
                <nmfta-button [blackText]="true" rightIcon="keyboard_arrow_down" [matMenuTriggerFor]="MenuProposal">
                  Proposals
                </nmfta-button>
                <mat-menu #MenuProposal="matMenu">
                  <button mat-menu-item [routerLink]="'proposals/steps'"> Create Proposal </button>
                  <button mat-menu-item [routerLink]="'proposals/manage-proposals'"> Manage Proposals </button>
                </mat-menu>

                <!-- DOCKETS -->
                <nmfta-button [blackText]="true" rightIcon="keyboard_arrow_down" [matMenuTriggerFor]="MenuDocket">
                  Dockets
                </nmfta-button>
                <mat-menu #MenuDocket="matMenu">
                  @if(isClassificationManager$()) {
                    <button mat-menu-item [routerLink]="'dockets/create-docket'"> Generate Docket </button>
                  }
                  <button mat-menu-item [routerLink]="'dockets/manage-dockets'"> Manage Dockets </button>
                </mat-menu>

                <!-- DISPOSITION BULLETIN -->
                <nmfta-button [blackText]="true" rightIcon="keyboard_arrow_down" [matMenuTriggerFor]="MenuBulletin">
                  Disposition Bulletins
                </nmfta-button>
                <mat-menu #MenuBulletin="matMenu">
                  <button mat-menu-item [routerLink]="'disposition-bulletin/generate-disposition-bulletin'">
                    Generate Disposition Bulletin
                  </button>
                  <button mat-menu-item [routerLink]="'disposition-bulletin/manage-disposition-bulletins'">
                    Manage Disposition Bulletins
                  </button>
                </mat-menu>

                <!-- SUPPLEMENTS -->
                <nmfta-button [blackText]="true" rightIcon="keyboard_arrow_down" [matMenuTriggerFor]="MenuSupplement">
                  Supplements
                </nmfta-button>
                <mat-menu #MenuSupplement="matMenu">
                  <button mat-menu-item [routerLink]="'supplement/manage-index'">
                    Manage Index
                  </button>
                  <button mat-menu-item [routerLink]="'supplement/generate-supplement'"> Generate Supplement </button>
                  <button mat-menu-item [routerLink]="'supplement/manage-supplements'"> Manage Supplements </button>
                  <button mat-menu-item [routerLink]="'supplement/manage-global-synonyms'">
                    Manage Global Synonyms
                  </button>
                  <button mat-menu-item [routerLink]="'supplement/generate-orphaned-items-report'">
                    Generate Orphaned Items Report
                  </button>
                </mat-menu>

                <!-- BOOK -->
                <nmfta-button [blackText]="true" rightIcon="keyboard_arrow_down" [matMenuTriggerFor]="MenuBook">
                  Book
                </nmfta-button>
                <mat-menu #MenuBook="matMenu">
                  <button mat-menu-item [routerLink]="'book/generate-book-file'"> Generate Book File </button>
                  <button mat-menu-item [routerLink]="'book/manage-book-files'"> Manage Book Files </button>
                </mat-menu>

                <!-- OTHER -->
                <nmfta-button [blackText]="true" rightIcon="keyboard_arrow_down" [matMenuTriggerFor]="MenuOther">
                  Other
                </nmfta-button>
                <mat-menu #MenuOther="matMenu">
                  <button mat-menu-item [matMenuTriggerFor]="SubMenuDataFiles"> Data Files </button>
                  <button mat-menu-item [matMenuTriggerFor]="SubMenuDensitySheet"> Density Sheet </button>
                </mat-menu>

                <mat-menu #SubMenuDataFiles="matMenu">
                  <button mat-menu-item [routerLink]="'data-files/generate-data-files'"> Generate Data Files </button>
                  <button mat-menu-item [routerLink]="'data-files/manage-data-files'"> Manage Data Files </button>
                </mat-menu>

                <mat-menu #SubMenuDensitySheet="matMenu">
                  <button mat-menu-item [routerLink]="'density-sheet/generate-density-sheet'">
                    Generate Density Sheet
                  </button>
                  <button mat-menu-item [routerLink]="'density-sheet/manage-density-sheet'">
                    Manage Density Sheet
                  </button>
                </mat-menu>
              </div>
            }
          }
          </div>
        }
      </div>
    </div>
  }
</nav>

<ng-template #nmfcBookModalTemplate>
  <div class="container-fluid">
    <div class="row p-1 p-md-3">
      <div class="row p-1 p-md-3">
        <p class="welcome-message" [innerHTML]="'NMFC_BOOK.2026_BOOK_AVAILABLE_MESSAGE' | translate"></p>
      </div>
    </div>
  </div>
</ng-template>

<div class="overlay" [class.open]="isOpen">
  <div class="nav-menu-content" [class.d-none]="!isOpen">
    <div class="nav-menu-header container">
      <div class="logo-column logo-mobile" (click)="navigate('home')">
        <img src="assets/images/classit_logo_publishing.svg" alt="logo" />
      </div>
      <div class="menu-colum">
        @if (hasUserInformation$()) {
          <nmfta-button
            [blackText]="true"
            iconName="file_download"
            (buttonClick)="openDownloadsPanel()">
          </nmfta-button>
        }
        <!-- CLOSE MENU -->
        <nmfta-button [blackText]="true" iconName="close" (buttonClick)="toggleNavMenu()"></nmfta-button>
      </div>
    </div>

    <div class="nav-menu-body container">
      @if (userLoading$()) {
        <div class="menu-loading">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '100%',
              height: '21rem',
              'border-radius': '0.5rem',
            }">
          </ngx-skeleton-loader>
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '100%',
              height: '3rem',
              'border-radius': '0.5rem',
            }">
          </ngx-skeleton-loader>
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '100%',
              height: '9rem',
              'border-radius': '0.5rem',
            }">
          </ngx-skeleton-loader>
        </div>
      } @else {
        @if (hasUserInformation$()) {
          <div class="menu-items">
            <mat-accordion>
              <div matRipple class="menu-item" (click)="navigate('home')">
                <span>{{ 'Generic_Home' | translate }}</span>
              </div>
              <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                <mat-expansion-panel-header>
                  <mat-panel-title>Proposals</mat-panel-title>
                  <mat-icon class="custom-icon">expand_more</mat-icon>
                </mat-expansion-panel-header>
                <div matRipple class="menu-item" (click)="navigate('proposals/create-proposal')">
                  <span>Create Proposal</span>
                </div>
                <div matRipple class="menu-item" (click)="navigate('proposals/manage-proposals')">
                  <span>Manage Proposals</span>
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                <mat-expansion-panel-header>
                  <mat-panel-title>Dockets</mat-panel-title>
                  <mat-icon class="custom-icon">expand_more</mat-icon>
                </mat-expansion-panel-header>
                @if(isClassificationManager$()) {
                  <div matRipple class="menu-item" (click)="navigate('dockets/create-docket')">
                    <span>Generate Docket</span>
                  </div>
                }
                <div matRipple class="menu-item" (click)="navigate('dockets/manage-dockets')">
                  <span>Manage Dockets</span>
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                <mat-expansion-panel-header>
                  <mat-panel-title>Disposition Bulletins</mat-panel-title>
                  <mat-icon class="custom-icon">expand_more</mat-icon>
                </mat-expansion-panel-header>
                <div
                  matRipple
                  class="menu-item"
                  (click)="navigate('disposition-bulletin/generate-disposition-bulletin')">
                  <span>Generate Disposition Bulletin</span>
                </div>
                <div
                  matRipple
                  class="menu-item"
                  (click)="navigate('disposition-bulletin/manage-disposition-bulletins')">
                  <span>Manage Disposition Bulletins</span>
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                <mat-expansion-panel-header>
                  <mat-panel-title>Supplements</mat-panel-title>
                  <mat-icon class="custom-icon">expand_more</mat-icon>
                </mat-expansion-panel-header>
                <div
                  matRipple
                  class="menu-item"
                  (click)="navigate('supplement/manage-index')">
                  <span>Manage Index</span>
                </div>
                <div matRipple class="menu-item" (click)="navigate('supplement/generate-supplement')">
                  <span>Generate Supplement</span>
                </div>
                <div matRipple class="menu-item" (click)="navigate('supplement/manage-supplements')">
                  <span>Manage Supplements</span>
                </div>
                <div matRipple class="menu-item" (click)="navigate('supplement/manage-global-synonyms')">
                  <span>Manage Global Synonyms</span>
                </div>
                <div matRipple class="menu-item" (click)="navigate('supplement/generate-orphaned-items-report')">
                  <span>Generate Orphaned Items Report</span>
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                <mat-expansion-panel-header>
                  <mat-panel-title>Book</mat-panel-title>
                  <mat-icon class="custom-icon">expand_more</mat-icon>
                </mat-expansion-panel-header>
                <div matRipple class="menu-item" (click)="navigate('book/generate-book-file')">
                  <span>Generate Book File</span>
                </div>
                <div matRipple class="menu-item" (click)="navigate('book/manage-book-files')">
                  <span>Manage Book Files</span>
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                <mat-expansion-panel-header class="no-border">
                  <mat-panel-title>Other</mat-panel-title>
                  <mat-icon class="custom-icon">expand_more</mat-icon>
                </mat-expansion-panel-header>
                <mat-expansion-panel
                  #subPanel="matExpansionPanel"
                  (opened)="subPanelOpenState.set(true)"
                  (closed)="subPanelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title>Data Files</mat-panel-title>
                    <mat-icon class="custom-icon">expand_more</mat-icon>
                  </mat-expansion-panel-header>
                  <div matRipple class="menu-item" (click)="navigate('data-files/generate-data-files')">
                    <span>Generate Data Files</span>
                  </div>
                  <div matRipple class="menu-item" (click)="navigate('data-files/manage-data-files')">
                    <span>Manage Data Files</span>
                  </div>
                </mat-expansion-panel>
                <mat-expansion-panel
                  #subPanel="matExpansionPanel"
                  (opened)="subPanelOpenState.set(true)"
                  (closed)="subPanelOpenState.set(false)">
                  <mat-expansion-panel-header class="no-border">
                    <mat-panel-title>Density Sheet</mat-panel-title>
                    <mat-icon class="custom-icon">expand_more</mat-icon>
                  </mat-expansion-panel-header>
                  <div matRipple class="menu-item" (click)="navigate('density-sheet/generate-density-sheet')">
                    <span>Generate Density Sheet</span>
                  </div>
                  <div matRipple class="menu-item" (click)="navigate('density-sheet/manage-density-sheet')">
                    <span>Manage Density Sheet</span>
                  </div>
                </mat-expansion-panel>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        }

        <div class="menu-items">
          <mat-accordion>
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
              <mat-expansion-panel-header class="no-border">
                <mat-panel-title>
                  <mat-icon class="me-2">language</mat-icon>
                  <span>{{ langLabel }}</span>
                </mat-panel-title>
                <mat-icon class="custom-icon">expand_more</mat-icon>
              </mat-expansion-panel-header>
              <div matRipple class="menu-item" (click)="useLanguage('en')">
                @if (langSelected === 'en') {
                  <mat-icon fontSet="material-icons-outlined" class="me-2">check</mat-icon>
                }
                <span>{{ 'Generic_English' | translate }}</span>
              </div>
              <div matRipple class="menu-item" (click)="useLanguage('fr')">
                @if (langSelected === 'fr') {
                  <mat-icon fontSet="material-icons-outlined" class="me-2">check</mat-icon>
                }
                <span>{{ 'Generic_French' | translate }}</span>
              </div>
              <div matRipple class="menu-item no-border" (click)="useLanguage('es')">
                @if (langSelected === 'es') {
                  <mat-icon fontSet="material-icons-outlined" class="me-2">check</mat-icon>
                }
                <span>{{ 'Generic_Spanish' | translate }}</span>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>

        <div class="menu-items">
          <mat-accordion>
            @if (hasUserInformation$()) {
              <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                <mat-expansion-panel-header>
                  <mat-panel-title>{{ user$.firstName!() + ' ' + user$.lastName!() }}</mat-panel-title>
                  <mat-icon class="custom-icon">expand_more</mat-icon>
                </mat-expansion-panel-header>
                <div matRipple class="menu-item custom-red-button" (click)="signOut()">
                  <mat-icon class="me-2">logout</mat-icon>
                  <span>{{ 'Generic_Logout' | translate }}</span>
                </div>
              </mat-expansion-panel>

              @if (isClassificationManager$()) {
                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header class="no-border">
                    <mat-panel-title>
                      {{ 'Generic_Admin' | translate }}
                    </mat-panel-title>
                    <mat-icon class="custom-icon">expand_more</mat-icon>
                  </mat-expansion-panel-header>
                  <div matRipple class="menu-item" (click)="navigate('admin/manage-publishing-cycle')">
                    {{ 'Generic_ManagePublishingCycle' | translate }}
                  </div>
                  <div matRipple class="menu-item" (click)="navigate('admin/manage-distribution-channels')">
                    {{ 'Generic_ManageDistributionChannels' | translate }}
                  </div>

                  <div matRipple class="menu-item" (click)="navigate('admin/manage-proposal-templates')">
                    {{ 'Generic_ManageProposalTemplatesFields' | translate }}
                  </div>
                  <mat-expansion-panel
                    #subPanel="matExpansionPanel"
                    (opened)="subPanelOpenState.set(true)"
                    (closed)="subPanelOpenState.set(false)">
                    <mat-expansion-panel-header>
                      {{ 'Generic_ManageReviewProcess' | translate }}
                      <mat-icon class="custom-icon">expand_more</mat-icon>
                    </mat-expansion-panel-header>
                    <div matRipple class="menu-item" (click)="navigate('admin/manage-workflows')">
                      {{ 'Generic_ManageWorkflow' | translate }}
                    </div>
                    <div matRipple class="menu-item" (click)="navigate('admin/manage-reviewers-approvers')">
                      {{ 'Generic_ManageReviewersAndApprovers' | translate }}
                    </div>
                  </mat-expansion-panel>
                  <div matRipple class="menu-item" (click)="navigate('admin/manage-disposition-definitions')">
                    {{ 'Generic_ManageDispositionDefinitions' | translate }}
                  </div>
                  <div matRipple class="menu-item no-border" (click)="navigate('admin/manage-reference-marks')">
                    {{ 'Generic_ManageReferenceMarks' | translate }}
                  </div>
                </mat-expansion-panel>
              }
            } @else {
              <div matRipple class="menu-item" (click)="signIn()">
                <mat-icon class="me-2">login</mat-icon>
                <span>{{ 'Generic_Login' | translate }}</span>
              </div>
            }
            <div matRipple class="menu-item no-border" (click)="routeToExternalLink('https://nmfta.org/support/')">
              {{ 'Generic_ContactSupport' | translate }}
            </div>
          </mat-accordion>
        </div>
      }
    </div>
  </div>
  <div class="nav-menu-footer">
    <p>
      All content © Copyright 2024 National Motor Freight Traffic Association, Inc.™
      <br />All Rights Reserved.
    </p>
  </div>
</div>
